import React from 'react';
import {Link} from 'react-router-dom';

// components
import Searchbar from './searchbar';
// utils
import {loggedIn} from '../utils';

class Navbar extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showDropdown: false
    }
  }
  onHandleHoverAccount () {
    this.setState({showDropdown: true})
  }
  onHandleHoverLeaveAccount () {
    this.setState({showDropdown: false})
  }
  onHandleClickDropdownItem () {
    this.setState({showDropdown: false})
  }
  onHandleClickLogout () {
    this.setState({showDropdown: false});
    localStorage.setItem('login', false);
  }
  render () {
    const guestMode = ['/login', '/'].indexOf(window.location.pathname) >= 0;
    const onAccountPage = window.location.pathname == '/account';
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <Link className="navbar-brand" to="/">
            {/*<img src="/docs/4.2/assets/brand/bootstrap-solid.svg" width="30" height="30" className="d-inline-block align-top" 
                          alt=""/>*/}
            <i className="fas fa-tshirt icon fa-lg"></i>
            PJs
          </Link>

          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              

              {/* {!guestMode ? <Searchbar /> : null} */}
              <ul className="navbar-nav ml-auto">
                
                {/* <li className="nav-item" onMouseLeave={this.onHandleHoverLeaveAccount.bind(this)}>
                  <button className="btn btn-primary btn-upload">Upload</button>
                </li> */}
                {loggedIn() ? (<li className="nav-item" onMouseLeave={this.onHandleHoverLeaveAccount.bind(this)}>
                    <Link className="nav-link" to={{pathname: '/property'}}>Property</Link>
                  </li>) : null}
                {loggedIn() ? (<li className="nav-item" onMouseLeave={this.onHandleHoverLeaveAccount.bind(this)}>
                  <Link className="nav-link" to={{pathname: "/inbox"}}>Inbox</Link>
                </li>) : null}
                {loggedIn() ? (<li
                    onMouseOver={this.onHandleHoverAccount.bind(this)}>
                    <Link className="nav-link" to={{pathname: "/account"}} 
                      onClick={this.onHandleClickDropdownItem.bind(this)}>
                      <div className={onAccountPage ? "btn-account btn-account-active": "btn-account"}>
                        <i className="far fa-user-circle fa-2x"></i>
                      </div>
                    </Link>
                    <div className={this.state.showDropdown ? "dropdown-menu account-dropdown dropdown-show" : 
                    "dropdown-menu account-dropdown"}
                    onMouseLeave={this.onHandleHoverLeaveAccount.bind(this)}>
                      <Link className="dropdown-item" to={{pathname: "/account"}} 
                        onClick={this.onHandleClickDropdownItem.bind(this)}>Account</Link>
                      <Link className="dropdown-item" to={{pathname: "/", search: "?logout=true"}} 
                        onClick={this.onHandleClickLogout.bind(this)}>Logout</Link>
                    </div>
                  
                </li>) : null}
                {!loggedIn() ? (<li>
                  <Link className="nav-link" to={{pathname: "/login"}}>Login / Register</Link>
                </li>) : null}
              </ul>
            </div>
        </nav>
      )
  }
}

export default Navbar;